import { Box, Card, Image, Link } from "components/ui";
import { LinearGradient } from "expo-linear-gradient";
import { H5 } from "components/ui/Typography";
import React, { useState } from "react";
import Animated from "react-native-reanimated";
import { ViewStyle } from "react-native";
import { interpolate } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { withTiming } from "react-native-reanimated";
import { Easing } from "react-native-reanimated";
import { withRepeat } from "react-native-reanimated";
import { useSharedValue } from "react-native-reanimated";
import { ItemCategoryRead, abcoApi } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
type CategoryCardProps = {
	category: ItemCategoryRead;
};

export default function CategoryCard({ category }: CategoryCardProps) {
	var prefetchCategory = abcoApi.usePrefetch("getCategoryBySlug");
	var prefetchSubCategory = abcoApi.usePrefetch("getCategoryByCategorySlugAndSubCategorySlug");
	const [imageLoaded, setImageLoaded] = useState(false);
	const isMobile = useIsMobile();
	const ImageSkeleton = () => {
		const shimmerValue = useSharedValue(0);
		const pulseValue = useSharedValue(0);

		React.useEffect(() => {
			// Use yo-yo effect by setting reverse to true
			shimmerValue.value = withRepeat(
				withTiming(1, { duration: 1800, easing: Easing.inOut(Easing.ease) }),
				-1, // infinite repeats
				true, // yo-yo effect (reverses direction)
			);

			pulseValue.value = withRepeat(
				withTiming(1, { duration: 1200, easing: Easing.inOut(Easing.ease) }),
				-1,
				true, // yo-yo effect
			);
		}, []);

		const gradientStyle = useAnimatedStyle(() => {
			const translateX = interpolate(shimmerValue.value, [0, 1], [-300, 300]);

			return {
				position: "absolute",
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				transform: [{ translateX }],
			};
		});

		const pulseStyle = useAnimatedStyle(() => {
			return {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "#e0e0e0",
				opacity: 0.3 + pulseValue.value * 0.4, // Subtle but visible pulsing
				borderRadius: 20,
				borderTopLeftRadius: isMobile ? 8 : 20,
				borderTopRightRadius: isMobile ? 8 : 20,
			};
		});

		const containerStyle: ViewStyle = {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: "#e8e8e8", // Slightly lighter base color
			borderTopLeftRadius: isMobile ? 8 : 20,
			borderTopRightRadius: isMobile ? 8 : 20,
			overflow: "hidden",
		};

		return (
			<Box style={containerStyle}>
				<Animated.View style={pulseStyle} />
				<Animated.View style={gradientStyle}>
					<LinearGradient
						colors={["rgba(255,255,255,0)", "rgba(255,255,255,0.8)", "rgba(255,255,255,0)"]}
						start={{ x: 0, y: 0 }}
						end={{ x: 1, y: 0 }}
						style={{
							width: 300,
							height: "100%",
						}}
					/>
				</Animated.View>
			</Box>
		);
	};
	function doPrefetch() {
		if (category.categoryType === "Services") {
			return;
		}

		var url = category.url?.split("/");
		if (url == null) {
			return;
		}

		url.shift();
		url.shift();

		if (url.length == 1) {
			prefetchCategory({ slug: url[0] });
		} else if (url.length == 2) {
			prefetchSubCategory({ categorySlug: url[0], subCategorySlug: url[1] });
		}
	}

	return (
		<Link
			href={`${category.url}`}
			key={category.slug}
			onHoverIn={doPrefetch}
			component={(hovered: boolean) => {
				// @ts-ignore
				let imageSource = typeof category.imageUrl === "object" ? category.imageUrl?.uri + "?width=600&quality=75&format=webp" : process.env.EXPO_PUBLIC_ABCO_API_CDNURL + category.imageUrl + "?width=600&quality=75&format=webp";
				return (
					<Card
						w={"$full"}
						borderRadius={isMobile ? 8 : 20}
						style={{
							opacity: hovered ? 0.6 : 1,
							// @ts-ignore
							transition: "opacity 0.3s ease",
							overflow: "hidden",
						}}
					>
						<Box overflow="hidden" sx={{ borderTopLeftRadius: isMobile ? 8 : 20, borderTopRightRadius: isMobile ? 8 : 20 }}>
							{!imageLoaded && <ImageSkeleton />}
							{category.imageUrl != null ? (
								<Image
									aspectRatio={1}
									w={"$full"}
									source={imageSource}
									borderTopLeftRadius={isMobile ? 8 : 20}
									borderTopRightRadius={isMobile ? 8 : 20}
									style={{
										overflow: "hidden",
										width: "100%",
										flex: 1,
										transform: hovered ? "scale(1.05)" : "scale(1)",
										// @ts-ignore
										transition: "transform 0.3s ease",
									}}
									alt=""
								/>
							) : null}
						</Box>
						<Box backgroundColor="$darkbluexlight" p={isMobile ? 12 : 20} borderBottomLeftRadius={isMobile ? 8 : 20} borderBottomRightRadius={isMobile ? 8 : 20}>
							<H5>{category.name}</H5>
						</Box>
					</Card>
				);
			}}
		/>
	);
}
